export default "__VITE_ASSET__8Bn1rB7a__"